import * as React from 'react';
import { useRef, useState, useEffect } from 'react';
import request from 'src/utils/request';
import { NavLink } from 'react-router-dom';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  Modal,
  Backdrop,
  Grid,
  Tooltip
} from '@mui/material';

import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import { checkPermission } from '../../../../utils/permission';

import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ArticleIcon from '@mui/icons-material/Article';
import BadgeIcon from '@mui/icons-material/Badge';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);
let style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  textAlign: 'center',
  borderRadius: '8px',
  p: 5
};

function HeaderUserbox() {
  const [openMenuModal, setOpenMenuModal] = React.useState(false);
  const [openSettings, setOpenSettings] = React.useState(false);
  const [openGrossSettings, setOpenGrossSettings] = React.useState(false);
  const [rolePermissionViewPermission, setRolePermissionViewPermission] =
    useState(false);

  useEffect(() => {
    checkRolePermission();
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('RolePermission', 'View').then((permission) => {
      setRolePermissionViewPermission(permission);
    });
  };

  const [status, setStatus] = React.useState(false);
  const handleClick = () => {
    setOpenSettings(!openSettings);
  };
  const grossButtonhandleClick = () => {
    setOpenGrossSettings(!openGrossSettings);
  };

  const handleLogout = async () => {
    await logout();
    localStorage.clear();
    window.location.href = '/';
  };
  const user = {
    name: '',
    avatar: '',
    jobtitle: ''
  };
  const userDatas = JSON.parse(localStorage.getItem('userDatas'));
  let admin_window = localStorage.getItem('admin_window');
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const defaultCol =
    userDatas?.userData?.userType == 'Admin' &&
      userDatas?.userData?.activeBranchData?.userType == 'Admin'
      ? 4
      : 6;
  style.width =
    userDatas?.userData?.userType == 'Admin' &&
      userDatas?.userData?.activeBranchData?.userType == 'Admin'
      ? '68%'
      : 'auto';

  const handleOpen = (): void => {
    setOpen(true);
  };

  const logout = async () => {
    request({
      url: 'auth/logout',
      method: 'post',
      data: {
        id: userDatas?.userData.id
      }
    }).then(
      (response) => {
        return response;
      },
      (error) => {
        console.log(error);
      }
    );

  }

  const generateToken = async (type) => {
    request({
      url: 'auth/generateToken',
      method: 'post',
      data: {
        id: userDatas?.userData.id
      }
    }).then(
      (response) => {
        if (response['status']) {
          if (type === 'HRMS') {
            window.location.href =
              process.env.REACT_APP_HRMS_URL + response['crossToken'];
          }
          if (type === 'Accounts') {
            window.location.href =
              process.env.REACT_APP_ACCOUNTS_URL + response['crossToken'];
          }
        }
        return response;
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleMenuModalOpen = () => {
    setOpenMenuModal(true);
  };
  const handleMenuClose = () => {
    setOpenMenuModal(false);
    setStatus(!status);
  };

  const switchAdmin = async (type) => {
    localStorage.setItem('admin_window', type);
    handleClose();
    window.location.href = '/dashboards/dashboard';
  };

  return (
    <>
      <UserBoxButton className="icon-btn" onClick={handleMenuModalOpen}>
        <Hidden smDown>
          <Tooltip title="View Menus" arrow>
            <span
              style={{
                minWidth: '5vw',
                backgroundColor: 'rgba(85, 105, 255, 0.1)',
                color: 'rgb(85, 105, 255)',
                padding: '5px 16px',
                fontSize: '1rem',
                borderRadius: '10px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 600
              }}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <Grid item>
                  <>{admin_window ? admin_window === 'insuranceAdmin' ? 'Insurance Admin' : 'System Admin' : 'Insurance Admin'}</>
                </Grid>
                <Grid item sx={{ lineHeight: 0 }}>
                  <img
                    alt=""
                    width="22"
                    height="22"
                    src="/static/images/icons/globe-icon.svg"
                  />
                </Grid>
              </Grid>
            </span>
          </Tooltip>
        </Hidden>
      </UserBoxButton>
      <Modal
        open={openMenuModal}
        onClose={handleMenuClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            {userDatas?.userData?.userType == 'Admin' &&
              userDatas?.userData?.activeBranchData?.userType == 'Admin' &&
              admin_window == 'insuranceAdmin' && (
                <Grid
                  item
                  xs={defaultCol}
                  onClick={() => switchAdmin('SystemAdmin')}
                >
                  <div className="category-card">
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 1 }}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid style={{ marginTop: '.5vw' }}>
                        <SettingsSuggestIcon
                          style={{ color: '#0954ae', fontSize: '2.6rem' }}
                        />
                      </Grid>
                      <Grid style={{ marginTop: '.5vw' }}>
                        <h4>System Admin</h4>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              )}
            {userDatas?.userData?.userType == 'Admin' &&
              userDatas?.userData?.activeBranchData?.userType == 'Admin' &&
              admin_window == 'SystemAdmin' && (
                <Grid
                  item
                  xs={defaultCol}
                  onClick={() => switchAdmin('insuranceAdmin')}
                >
                  <div className="category-card">
                    <Grid
                      container
                      rowSpacing={1}
                      columnSpacing={{ xs: 1, sm: 2, md: 1 }}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Grid style={{ marginTop: '.5vw' }}>
                        <EnhancedEncryptionIcon
                          style={{ color: '#0954ae', fontSize: '2.6rem' }}
                        />
                      </Grid>
                      <Grid style={{ marginTop: '.5vw' }}>
                        <h4>Insurance Admin</h4>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              )}

            <Grid item xs={defaultCol} onClick={() => generateToken('HRMS')}>
              <div className="category-card">
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={2}>
                    <img
                      width="50"
                      height="50"
                      src="/static/images/icons/hrm-icon.svg"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <h4>HRM</h4>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <Grid
              item
              xs={defaultCol}
              onClick={() => generateToken('Accounts')}
            >
              <div className="category-card">
                <Grid
                  container
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Grid item xs={2}>
                    <img
                      width="50"
                      height="50"
                      src="/static/images/icons/accounts-icon.svg"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <h4>Accounts</h4>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        {/* <Avatar variant="rounded" alt={userData.userData.firstname} /> */}
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {userDatas?.userData?.firstname}
            </UserBoxLabel>
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar
            src={userDatas?.userData?.photo}
            sx={{ width: 35, height: 35 }}
          />
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {userDatas?.userData?.firstname}
            </UserBoxLabel>
            <UserBoxDescription variant="body2">
              {userDatas?.userData?.activeBranchData?.role?.name}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav" className="userNav">
          {/* <ListItem button to="/dashboards/details" component={NavLink}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
          <ListItem button to="/dashboards/messenger" component={NavLink}>
            <InboxTwoToneIcon fontSize="small" />
            <ListItemText primary="Messenger" />
          </ListItem> */}
          <ListItem
            button
            to="/dashboards/settings"
            component={NavLink}
            onClick={handleClose}
          >
            <ManageAccountsIcon fontSize="small" />
            <ListItemText primary="Profile Settings" />
          </ListItem>

          {rolePermissionViewPermission ? (
            <ListItemButton onClick={handleClick}>
              <ListItemIcon>
                <SettingsIcon sx={{ ml: 0.7 }} fontSize="small" />
                <ListItemText
                  sx={{ ml: 0.7, mt: 0.2 }}
                  primary="Account Settings"
                />
              </ListItemIcon>
              {openSettings ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          ) : null}

          <Collapse in={openSettings} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* {userDatas.userData.userType === 'SuperAdmin' ? (
                <ListItemButton
                  sx={{ pl: 4 }}
                  to="/dashboards/feature"
                  component={NavLink}
                >
                  <ListItemIcon>
                    <LibraryBooksIcon />
                  </ListItemIcon>
                  <ListItemText primary="Feature" />
                </ListItemButton>
              ) : null}
              {userDatas.userData.userType === 'SuperAdmin' ? (
                <ListItemButton
                  sx={{ pl: 4 }}
                  to="/dashboards/permissions"
                  component={NavLink}
                >
                  <ListItemIcon>
                    <AdminPanelSettingsIcon />
                  </ListItemIcon>
                  <ListItemText primary="Permissions" />
                </ListItemButton>
              ) : null} */}
              <ListItemButton
                dense
                sx={{ pl: 4, ml: 1.8 }}
                to="/dashboards/rolePermissions"
                component={NavLink}
                onClick={handleClose}
              >
                <ListItemIcon
                  sx={{
                    marginRight: -3 // Adjust the margin between ListItemButton and ListItemIcon
                  }}
                >
                  <BadgeIcon sx={{ fontSize: 24 }} />
                </ListItemIcon>
                <ListItemText primary="Roles" onClick={handleClose} />
              </ListItemButton>
              {/* <ListItemButton sx={{ pl: 4 }} to="/dashboards/tasks" component={NavLink}>
                <ListItemIcon>
                  <AssignmentIcon />
                </ListItemIcon>
                <ListItemText primary="Task Definition" />
              </ListItemButton> */}
              {userDatas?.userData?.userType === 'SuperAdmin' ? (
                <ListItemButton
                  dense
                  sx={{ pl: 4, ml: 1.8 }}
                  to="/dashboards/staticForms"
                  component={NavLink}
                  onClick={handleClose}
                >
                  <ListItemIcon
                    sx={{
                      marginRight: -3 // Adjust the margin between ListItemButton and ListItemIcon
                    }}
                  >
                    <ArticleIcon sx={{ fontSize: 24 }} />
                  </ListItemIcon>
                  <ListItemText primary="Static Forms" onClick={handleClose} />
                </ListItemButton>
              ) : null}
            </List>
          </Collapse>
          {/* <ListItemButton onClick={grossButtonhandleClick}>
            <ListItemIcon>
              <AttachMoneyIcon fontSize="small" />
              <ListItemText primary="Gross Settings" />
            </ListItemIcon>
            {openGrossSettings ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton> */}
          {/* <Collapse in={openGrossSettings} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItemButton
                sx={{ pl: 4 }}
                to="/dashboards/zones"
                component={NavLink}
              >
                <ListItemIcon>
                  <LibraryBooksIcon />
                </ListItemIcon>
                <ListItemText primary="Zones" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                to="/dashboards/grades"
                component={NavLink}
              >
                <ListItemIcon>
                  <AdminPanelSettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Grades" />
              </ListItemButton>
              <ListItemButton
                sx={{ pl: 4 }}
                to="/dashboards/gross"
                component={NavLink}
              >
                <ListItemIcon>
                  <AdminPanelSettingsIcon />
                </ListItemIcon>
                <ListItemText primary="Gross" />
              </ListItemButton>
            </List>
          </Collapse> */}
        </List>
        <Divider />
        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={handleLogout}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Sign out
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
